module.exports = __webpack_public_path__ + "assets/images/standards-analysis.92f0c32a91166c562d788c003d883cd7.svg";